import React from 'react'
import PropTypes from 'prop-types'

import SignInUserPage from './components/signin/SignInUserPage';
import SignUpUserPage from './components/signup/SignUpUserPage';
import FluxAuthenticationActions from '../actions/FluxAuthenticationActions';
import CurrentUserStore from '../stores/CurrentUserStore';
import BrowserLocationHelper from '../utils/browser_location_helper';

import registerUserSessionToIntercom from '../utils/Intercom/registerUserSessionToIntercom'
import { setCSRFToken } from "../apis/base";

export default class UserSessionForm extends React.Component {

    static propTypes = {
        redirectURL: PropTypes.string,
        csrfToken: PropTypes.string.isRequired,
        email: PropTypes.string,
        inviter_referral_code: PropTypes.string
    };

    state = {
        showSignIn: this.props.showSignIn || false,
        currentUser: null,
        missingCsrfToken: false
    };

    componentDidMount() {
      const { csrfToken } = this.props;

        if (!csrfToken) {
          this.setState({missingCsrfToken: true})
          return;
        }

        setCSRFToken(this.props.csrfToken)
        CurrentUserStore.addChangeListener(this._onCurrentUserChange);
    }

    componentWillUnmount() {
        CurrentUserStore.removeChangeListener(this._onCurrentUserChange);
    }

    _onCurrentUserChange = () => {
        const newUser = CurrentUserStore.getUser();

        if (this.state.currentUser !== newUser) {
            this.setState({
                currentUser: newUser
            });

            if (this.props.redirectURL) {
                BrowserLocationHelper.ChangeURL(this.props.redirectURL);
            }
        }
    };

    onLogin = (user) => {
        FluxAuthenticationActions.logged(user);
        registerUserSessionToIntercom(user)
    };

    signUpButtonClicked = () => {
        this.setState({showSignIn: false});
    };

    signInButtonClicked = () => {
        this.setState({showSignIn: true});
    };

    renderWelcomeUser() {
        return (
            <div className="text-center">
                <div>
                    <h2>👋 {this.state.currentUser.first_name}</h2>
                </div>

                <a href="/">Torna alla home</a>
            </div>
        )
    }

    isFacebookConnectEnabled() {
        return true;
    }

    renderForms() {
        if (this.state.showSignIn) {
            return <SignInUserPage onLogin={this.onLogin}
                                   signUpButtonClicked={this.signUpButtonClicked}
                                   facebookConnectEnabled={this.isFacebookConnectEnabled()}/>
        } else {
            return <SignUpUserPage onLogin={this.onLogin}
                                   email={this.props.email}
                                   signInButtonClicked={this.signInButtonClicked}
                                   facebookConnectEnabled={this.isFacebookConnectEnabled()}
                                   inviter_referral_code={this.props.inviter_referral_code}/>
        }
    }

    render() {
        if (this.state.missingCsrfToken) {
          return <div className={"alert alert-danger"}>Internal login form error, please contact the assistance</div>
        }

        return this.state.currentUser ? this.renderWelcomeUser() : this.renderForms();
    }
}
